import { BASE_API_URL } from 'src/app/environment';
import { axiosInstance } from '../client';

export type LatePlatform = 'twitter' | 'x' | 'instagram';

export async function getLateConnectUrl(
  platform: LatePlatform,
  lid?: string,
): Promise<string> {
  const url = `${BASE_API_URL}/integrations/connect/${platform}${
    lid ? `?lid=${encodeURIComponent(lid)}` : ''
  }`;
  const { data } = await axiosInstance.get(url);
  if (!data?.success || !data?.authUrl)
    throw new Error('Failed to get connect URL');
  return data.authUrl as string;
}

export async function openLateConnect(
  platform: LatePlatform,
  lid?: string,
): Promise<void> {
  const url = await getLateConnectUrl(platform, lid);
  window.open(url, '_blank', 'noopener,noreferrer');
}
